import { TarWriter } from "@gera2ld/tarjs";
import { FileSystemDirectoryHandle } from "./FileSytemHandle";
import { shouldExclude } from "./exclude";

// TODO: Add tests to ensure that the tarball same as the one created by the CLI
export const createTarBall = async (
  dirHandle: FileSystemDirectoryHandle,
  excludePatterns: string[]
) => {
  const writer = new TarWriter();
  await addDirectoryToTar(dirHandle, "", writer, excludePatterns);
  const blob = await writer.write();

  return blob;
};

const addDirectoryToTar = async (
  dirHandle: FileSystemDirectoryHandle,
  relativePath: string,
  writer: TarWriter,
  excludePatterns: string[]
) => {
  for await (const entry of dirHandle.values()) {
    const entryPath = `${relativePath}${entry.name}`;

    // eslint-disable-next-line no-continue
    if (shouldExclude(excludePatterns, entryPath)) continue;

    if (entry.kind === "file") {
      writer.addFile(entryPath, await entry.getFile());
    } else if (entry.kind === "directory") {
      writer.addFolder(entryPath);
      await addDirectoryToTar(entry, `${entryPath}/`, writer, excludePatterns);
    }
  }
};
